import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import WorkActivity from "./tabs/WorkActivity";
import { Wrapper } from "../styled";

const workExperiencedsTabs = [
{
    title: "Трудовая деятельность(включая все виды учебы, воинскую службу)",
    component: <WorkActivity/>,
}
];

const WorkExperience: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {workExperiencedsTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {workExperiencedsTabs[tab].component}
    </Wrapper>
);
};

export default WorkExperience;
